import { baseSplitApi } from "../baseApi";
import { newLoginTag } from "../userAuth";

const downloadReportPath = '/attendance/report'


export const downloadReportApi = baseSplitApi.injectEndpoints({
    endpoints: (build) => ({
        downloadReport: build.mutation({
            query: () => {
                return {
                    url: downloadReportPath,
                    method: 'GET',
                   
                }
            },
            providesTags: [newLoginTag]
        }),
    }),
    overrideExisting: false,
}
);

export const { useDownloadReportMutation } = downloadReportApi